import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';

interface MediaResponse<T> {
  data: T;
  message?: string;
  status?: number;
}

@Injectable({ providedIn: 'root' })
export class PaymentService {
  constructor(private api: ApiService) {}

  /**
   * GET /payment/token
   * Token có hạn trong vòng 4h (backend).
   */
  getTokenMoney(): Observable<string> {
    return this.api.get<MediaResponse<string>>('payment/token').pipe(map(res => res?.data));
  }
}
